// Keep the existing call sites while using the platform font stack. Loading
// Outfit on every route added an 84 KB render-critical font request and made
// text headings (including listing-page LCP elements) wait unnecessarily.
export const montserrat = { className: "font-heading" };
